import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { environment } from './environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private loaded = false;
  private configuration: any;

  constructor() {
    // Load the environment directly from TS file
    this.configuration = _.cloneDeep(environment);
    this.loaded = true;
  }

  /**
   * Get the loaded configuration
   */
  public getConfig(): any {
    if (!this.loaded) {
      console.warn('Environment not loaded yet.');
    }
    return this.configuration;
  }
}